import { useState } from 'react';
import { BaseItem } from './base-item';

export interface ItemProps {
  id: string;
  image: string;
  title: string;
  isObtained?: boolean;
  onClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
  onRightClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
  onToggle?: (obtained: boolean) => void;
  tooltip?: string;
  displayName?: boolean;
  childItem?: string;
  displayChildItem?: boolean;
}

export function Item(props: ItemProps) {
  const [localObtained, setLocalObtained] = useState(props.isObtained ?? false);
  const [isWoth, setIsWoth] = useState(false);

  const isObtained = props.isObtained ?? localObtained;

  const handleClick = (e: React.MouseEvent<HTMLImageElement>) => {
    if (e.ctrlKey || e.shiftKey) {
      setIsWoth(!isWoth);
      return;
    }

    if (props.onClick) {
      props.onClick(e);
      return;
    }

    const next = !isObtained;
    setLocalObtained(next);
    props.onToggle?.(next);
  };

  const handleRightClick = (e: React.MouseEvent<HTMLImageElement>) => {
    e.preventDefault();
    if (props.onRightClick) {
      props.onRightClick(e);
      return;
    }
    const next = !isObtained;
    setLocalObtained(next);
    props.onToggle?.(next);
  };

  return (
    <div className={`flex ${isWoth ? 'ring-1 ring-yellow-400 rounded-sm' : ''}`}>
      <BaseItem
        id={props.id}
        image={props.image}
        title={props.title}
        isObtained={isObtained}
        onClick={handleClick}
        onRightClick={handleRightClick}
        tooltip={props.tooltip}
        displayName={props.displayName}
        childItem={props.childItem}
        displayChildItem={props.displayChildItem}
      />
    </div>
  );
}
